import {Container} from "react-bootstrap";
import React from "react";
import HomeCard from "./HomeCard";
import iBigCard from "./ibig-card.jpg"
import investCard from './pexels-cottonbro-studio-4065895 1.png'
import vcCard from './pexels-cottonbro-studio-10679208 1.png'


const HomeCards = () => {

    const homeCards = [
        {
            title: "Impact Business Investment Group (iBig)",
            description: "Architecting scalable, purpose-driven ventures at the intersection of technology and sustainability.\n" +
                "\n" +
                "We combine enterprise SaaS innovation with ESG-driven impact to deliver superior returns while reshaping the future of business.",
            image: iBigCard,
            side: 'left'
        },
        {
            title: "We invest in the entrepreneurs of tomorrow!",
            description: "Our investment group is a scaling engine, not just a capital injection vehicle. We build successful businesses with strongly driven and ambitious entrepreneurs and execution teams.",
            image: investCard,
            side: 'right'
        },
        {
            title: "We are not a traditional VC",
            description: "We are building a global conglomerate of impact driven deeply embedded businesses across industries that changes the way business is done with a mission of changing the world for the better of all people and the planet.",
            image: vcCard,
            side: 'left'
        }
    ]

    return (
        <Container className={'mt-5 px-5 portfolio-items'}>
            {homeCards.map((card, index) => (
                <HomeCard title={card.title} description={card.description} image={card.image} side={card.side || 'left'} key={index} />
            ))}
        </Container>
    );
}

export default HomeCards;
